import { render, staticRenderFns } from "./appointment_administrative.vue?vue&type=template&id=4ccf03a0"
import script from "./appointment_administrative.vue?vue&type=script&lang=js"
export * from "./appointment_administrative.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports